<script>
	import { getContext } from 'svelte'
	import { styles } from '../scripts/styles.js'

	const globals = getContext('globals')
	export let fontSize = globals.fsS
	export let backgroundColor = globals.inputBgFocus
	export let width = '100%'
	export let errorMessage = 'this field is mandatory'
	export let errorType = 'input'
	export let rows = '6'
	export let resize = 'none'
	const colorError = globals.colorError
</script>

<main use:styles={{ width }}>
	{#if errorType === 'input'}
		<div class="error" use:styles={{ fontSize, colorError, backgroundColor, width }}>{errorMessage}</div>
	{/if}

	{#if errorType === 'textarea'}
		<div>
			<textarea
				class="errorTextarea"
				use:styles={{ fontSize, colorError, backgroundColor, width, resize }}
				value={errorMessage}
				{rows}
				readonly
			/>
		</div>
	{/if}
</main>

<style>
	.error {
		font-size: var(--fontSize);
		color: var(--colorError);
		background: var(--backgroundColor);
		outline: none;
		width: var(--width);
		padding: 6px;
		border: 1px solid var(--colorError);
		text-align: center;
	}

	.errorTextarea {
		font-size: var(--fontSize);
		color: var(--colorError);
		background: var(--backgroundColor);
		outline: none;
		width: var(--width);
		margin: 0;
		padding: 6px;
		border: 1px solid var(--colorError);
		resize: var(--resize);
	}
</style>
